import { useMutation } from '@tanstack/react-query'

import { updateBatterySoC } from '@/features/resource/endpoints/resources'

export function useUpdateBatterySoCMutation() {
  const { mutateAsync, ...mutationResult } = useMutation({
    mutationFn: (params: { resourceId: string; desiredSoC: number }) =>
      updateBatterySoC(params.resourceId, params.desiredSoC),
  })

  return {
    updateBatterySoC: mutateAsync,
    ...mutationResult,
  }
}
